import ButtonExtended from './ButtonExtended'

export default ButtonExtended
